export default {
  accounts: {
    menu: 'Contas'
  },
  communication: {
    menu: 'Comunicação'
  },
  configuration: {
    menu: 'Configurações'
  },
  core: {
    menu: 'Ecossistema'
  },
  crm: {
    menu: 'CRM'
  },
  dashboards: {
    menu: 'Dashboards'
  },
  documentation: {
    menu: 'Documentação'
  },
  erp: {
    menu: 'ERP'
  },
  global: {
    menu: 'Global'
  },
  governance: {
    menu: 'Governança'
  },
  operations: {
    menu: 'Operações'
  },
  people: {
    menu: 'Pessoas'
  },
  platform: {
    menu: 'Plataforma'
  },
  project: {
    menu: 'Gestão de Projetos'
  },
  security: {
    menu: 'Segurança'
  },
  service: {
    menu: 'Atendimento'
  },
  sectors: {
    menu: 'Setores'
  },
  webadmin: {
    menu: 'Administrador Web'
  },
  webmanager: {
    menu: 'Gerenciador Web'
  }
};
